var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import { combineReducers } from 'redux';
import * as actions from '../actions';

function visible() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case actions.ACTIVAR:
    case actions.MOSTRAR:
      return true;

    case actions.OCULTAR:
      return false;

    default:
      return state;
  }
}

function activa() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  var action = arguments[1];

  switch (action.type) {
    case actions.ACTIVAR:
      return true;

    case actions.DESACTIVAR:
      return false;

    default:
      return state;
  }
}

function posicion() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    left: 0,
    top: 0,
    right: 0,
    bottom: 0
  };
  var action = arguments[1];

  switch (action.type) {
    case actions.RESETEAR:
      return {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      };

    case actions.POSICION:
      return _extends({}, action.posicion);

    default:
      return state;
  }
}

var persiana = combineReducers({
  activa: activa,
  visible: visible,
  posicion: posicion
});
export default persiana;